export const DENSITY_KEY = 'provi_restaurant_density';
export const ACTIVE_CART_KEY = 'provi_food_active_restaurant';
export const ADDRESS_KEY = 'provi_food_delivery_address';

export const terminalFoodStatuses = new Set([
  'delivered',
  'cancelled',
  'rejected_by_restaurant'
]);

export const foodStatusSteps = [
  { statuses: ['pending_restaurant'], label: 'Pedido enviado' },
  { statuses: ['accepted_by_restaurant'], label: 'Aceptado por el restaurante' },
  { statuses: ['preparing'], label: 'En preparación' },
  { statuses: ['ready_for_pickup', 'waiting_delivery'], label: 'Listo para recoger' },
  { statuses: ['delivery_assigned'], label: 'Repartidor asignado' },
  { statuses: ['picked_up', 'on_the_way'], label: 'En camino' },
  { statuses: ['delivered'], label: 'Entregado' }
];

export const formatMoney = (value) =>
  new Intl.NumberFormat('es-EC', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(Number(value || 0));

export const cartStorageKey = (restaurantId) =>
  `provi_food_cart_${restaurantId}`;

export function readJsonStorage(key, fallback) {
  try {
    const stored = window.localStorage.getItem(key);
    return stored ? JSON.parse(stored) : fallback;
  } catch {
    window.localStorage.removeItem(key);
    return fallback;
  }
}

export function normalizeCartItem(product, quantity = 1, observation = '') {
  const normalizedObservation = observation.trim();
  return {
    line_id: `${product.id}::${normalizedObservation}`,
    menu_item_id: product.id,
    name: product.name,
    price: Number(product.price || 0),
    image_url: product.image_url || '',
    quantity: Math.max(1, Number(quantity || 1)),
    observation: normalizedObservation
  };
}

export function hydrateCart(cart) {
  return (Array.isArray(cart) ? cart : []).map((item) => ({
    ...item,
    quantity: Math.max(1, Number(item.quantity || item.qty || 1)),
    line_id: item.line_id || `${item.menu_item_id}::${String(item.observation || '').trim()}`
  }));
}

export function calculateSubtotal(cart) {
  return cart.reduce(
    (sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0),
    0
  );
}

export function cartCount(cart) {
  return cart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
}

export function restaurantMatches(restaurant, query) {
  if (!query.trim()) return true;
  const needle = query.trim().toLocaleLowerCase('es');
  return [
    restaurant.name,
    restaurant.category,
    restaurant.description,
    restaurant.promo_text
  ].some((value) => String(value || '').toLocaleLowerCase('es').includes(needle));
}

export function isRestaurantOrderable(restaurant) {
  return Boolean(
    restaurant
    && restaurant.active !== false
    && restaurant.approved !== false
    && restaurant.delivery_enabled === true
  );
}

export function getRestaurantDeliveryLabel(restaurant) {
  return isRestaurantOrderable(restaurant)
    ? 'Delivery habilitado'
    : 'No disponible para delivery';
}

export function productMatches(product, query) {
  if (!query.trim()) return true;
  const needle = query.trim().toLocaleLowerCase('es');
  return [product.name, product.description]
    .some((value) => String(value || '').toLocaleLowerCase('es').includes(needle));
}

export function getReadableAddress(location) {
  const address = String(location?.address || '').trim();
  const reference = String(location?.reference || '').trim();
  if (address) return address;
  if (reference) return reference;
  return 'Selecciona tu dirección';
}

export function isValidDeliveryLocation(location) {
  return Number.isFinite(Number(location?.lat))
    && Number.isFinite(Number(location?.lng))
    && Boolean(String(location?.address || location?.reference || '').trim());
}

export function getOrderDate(order) {
  if (!order?.created_at) return '';
  const date = new Date(order.created_at);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('es-EC', {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(date);
}

export function orderStepIndex(status) {
  return foodStatusSteps.findIndex((step) => step.statuses.includes(status));
}

export function initials(name) {
  return String(name || 'P')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}
